import React from "react";
import AboutMain from "../components/About/AboutMain";

function AboutPage() {
  return (
    <>
      <div className="">
        <AboutMain />
      </div>
    </>
  );
}

export default AboutPage;
